import React from 'react';
import NoData from '../../../components/Ui/NoData';

const MyWishlist = () => {
	return (
		<>
			<div>
				<h2 className="text-start">My Wishlist</h2>
				<div className="doted-container"></div>
			</div>
			<NoData />
		</>
	);
};

export default MyWishlist;
